'use client';
const SpacePropType = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    '0',
    '1',
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9',
    '10',
    '11',
    '12'
];
const SpaceDensityPropType = [
    'between-sections',
    'between-subsections',
    'between-actions',
    'to-actions',
    'between-icon-and-text'
];

export { SpaceDensityPropType, SpacePropType };
